import { render, staticRenderFns } from "./clueIndustryKeywordPage.vue?vue&type=template&id=89d4e104"
import script from "./clueIndustryKeywordPage.vue?vue&type=script&lang=js"
export * from "./clueIndustryKeywordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports